import Http from '../Http';

export class UsuarioService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`usuario/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`usuario/one/${id}`);
      return res.error ? null : res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async obtenerOpcionesForm(params: { initial_data?: boolean; cli_id?: any; cli_rs?: any } = {}) {
    try {
      const query = new URLSearchParams();
      if (params.initial_data) query.set('initial_data', 'true');
      if (params.cli_id) query.set('cli_id', params.cli_id.toString());
      if (params.cli_rs) query.set('cli_rs', params.cli_rs.toString());
      const res = await Http.get(`usuario/form?${query.toString()}`);
      return res.error ? null : res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: any) {
    try {
      const endpoint = data.id ? 'usuario/edit' : 'usuario/signup';
      const res = await Http.post(endpoint, data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error de conexión' };
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`usuario/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }
}
